var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "custom-table" },
    [
      _c(
        "vxe-table",
        {
          ref: "xTable",
          staticStyle: { "max-height": "400px", "overflow-y": "auto" },
          attrs: { border: "", "show-overflow": "", data: _vm.tableData },
        },
        [
          _c("vxe-table-column", {
            attrs: { type: "seq", width: "50", align: "center", title: "序号" },
          }),
          _c("vxe-table-column", {
            attrs: {
              field: "afterSeriesCode",
              align: "center",
              title: "变更后产品系列编码",
            },
          }),
          _c("vxe-table-column", {
            attrs: {
              field: "afterSeriesName",
              align: "center",
              title: "变更后产品系列名称",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }